import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/INSTITUTION_PREVIEW';
export const {action: fetchAllSuccess} = createAction(
    `${domain}/FETCH_ALL_SUCCESS`,
    (institutions, organizationId) => ({institutions, organizationId}),
);
